/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React, { useRef } from "react";
import { Eraser } from "lucide-react";

/* 手写签名板（触屏 / 鼠标）；onChange(dataUrl|null) */
export function SignPad({ onChange, testid = "sign-pad", height = 170, zh = true }) {
  const ref = useRef();
  const drawing = useRef(false);
  const dirty = useRef(false);
  const pos = (e) => { const c = ref.current; const r = c.getBoundingClientRect(); const t = e.touches ? e.touches[0] : e; return { x: (t.clientX - r.left) * (c.width / r.width), y: (t.clientY - r.top) * (c.height / r.height) }; };
  const start = (e) => { drawing.current = true; const ctx = ref.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); e.preventDefault(); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.strokeStyle = "#0f172a"; ctx.lineWidth = 2.5; ctx.lineCap = "round"; ctx.stroke(); dirty.current = true; e.preventDefault(); };
  const end = () => { if (drawing.current && dirty.current) onChange(ref.current.toDataURL("image/png")); drawing.current = false; };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(null); };
  return (
    <div>
      <canvas ref={ref} width={520} height={height} data-testid={testid}
        className="w-full rounded-lg border-2 border-dashed border-slate-300 bg-slate-50 touch-none cursor-crosshair" style={{ height: `${Math.round(height * 0.95)}px` }}
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end} />
      <button type="button" onClick={clear} data-testid={`${testid}-clear`} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 mt-1 text-[12px] text-slate-400 hover:text-red-500 flex items-center gap-1"><Eraser className="h-3 w-3" />{zh ? "清除重签" : "Clear"}</button>
    </div>
  );
}
